"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
var ValueStore_1 = require("./ValueStore");
var Query = (function (_super) {
    __extends(Query, _super);
    function Query(history, search) {
        if (search === void 0) { search = ""; }
        var _this = _super.call(this, toQueryObject(search)) || this;
        _this.history = history;
        return _this;
    }
    Query.prototype.set = function (key, value) {
        var _a;
        if (typeof key === "string") {
            this.replace(__assign(__assign({}, this.store), (_a = {}, _a[key] = String(value), _a)));
        }
        else {
            this.replace(__assign(__assign({}, this.store), key));
        }
    };
    Query.prototype.unset = function (key) {
        if (key !== undefined) {
            var current = __assign({}, this.store);
            if (Array.isArray(key)) {
                for (var _i = 0, key_1 = key; _i < key_1.length; _i++) {
                    var k = key_1[_i];
                    if (current[k] !== undefined) {
                        delete current[k];
                    }
                }
            }
            else {
                if (current[key] !== undefined) {
                    delete current[key];
                }
            }
            this.replace(current);
        }
        else {
            this.replace({});
        }
    };
    Query.prototype.replace = function (store) {
        this.history.push({ search: toQueryString(store) });
    };
    Query.prototype.toString = function () {
        return toQueryString(this.store);
    };
    return Query;
}(ValueStore_1.ValueStore));
exports.Query = Query;
function toQueryString(obj) {
    var query = [];
    for (var key in obj) {
        query.push(key + "=" + obj[key]);
    }
    if (query.length) {
        return "?" + query.join("&");
    }
    return "";
}
function toQueryObject(search) {
    var result = {};
    if (search) {
        search
            .replace("?", "")
            .split("&")
            .forEach(function (filter) {
            var _a = filter.split(/=(.+)/), key = _a[0], val = _a[1];
            result[key] = val;
        });
    }
    return result;
}
